import React, { Component } from 'react';
import SelectWrap from '../../components/SelectWrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';

import API from '../../services/API';
import countriesObj from "../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Bidder extends Component {

    constructor() {
        super();

        this.state = {
            countries: [],
            report: {},
            requests: {},
            sources: [],
            type: '',
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
    }

    handleSubmit(filters) {
        this.setState({
            isLoading: true
        });

        API.Bidder.get2(filters, this.state.type).then(({ report, requests }) => {
            this.setState({ report, requests, isLoading: false });
        });
    }

    handleCountryChange(event) {
        const { name, value } = event.target;

        const newValues = { [name]: value };

        if(name === 'sources' && value.length) newValues.countries = [ 'all' ];

        this.setState(newValues);
    }

    getTable() {
        const { countries, report, requests, sources } = this.state;
        const selectedCountries = countries && countries[0] === 'all' ? Object.keys(countriesObj) : countries;
        const selectedSources = sources.length ? sources : Object.keys(report);

        return Object.keys(report).length ?
            <Table data={report} requests={requests} countries={selectedCountries} sources={selectedSources}/> :
            <p>No Data</p>
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bidder2"/>
                <SelectWrap
                    values={countriesOptions}
                    label="Countries:"
                    name="countries"
                    onChange={this.handleCountryChange}
                    value={this.state.countries}
                    multi
                    required
                />
                <SelectWrap
                    values={Object.keys(this.state.report)}
                    label="Sources:"
                    name="sources"
                    onChange={this.handleCountryChange}
                    value={this.state.sources}
                    multi
                    required
                />
                <SelectWrap
                    values={{ '': 'Total', 'onw': 'Onw' }}
                    label="Type:"
                    name="type"
                    onChange={this.handleCountryChange}
                    value={this.state.type}
                    required
                />
                <Form onSubmit={this.handleSubmit}/>
                {this.getTable()}
            </Container>
        );
    }
}

export default Bidder;


// WEBPACK FOOTER //
// ./src/scenes/Bidder2/index.js